import * as _ from 'lodash';

angular.module("tromanWeb").factory('Property', ['$parse', function ($parse) {

    function Property(key, title, fnOrExpr, order) {
        this.key = key;
        this.fn = _.isFunction(fnOrExpr) ? fnOrExpr : $parse(fnOrExpr);
        this.title = title;
        this.ascending = true;
        this.order = order;
    }

    Property.prototype.listable = function listable(columnDefault, sorterDefault) {
        this.list = {
            defcol: columnDefault || 0,
            defsort: sorterDefault || 0
        };
        return this;
    };

    Property.prototype.descending = function descending() {
        this.ascending = false;
        return this;
    };

    return Property;
}]);

angular.module("tromanWeb").factory('Metadata', ['Property', 'isTroman', function (Property, isTroman) {

    function Metadata() {
        this.properties = [];
        this.propertyMap = Object.create(null);
        this.nextorder = 0;
    }

    Metadata.prototype.add = function add(key, title, expr) {
        var prop = new Property(key, title, expr || key, this.nextorder++);
        this.propertyMap[key] = prop;
        this.properties.push(prop);
        return prop;
    };

    Metadata.prototype.setSortingProperty = function setSortingProperty(key) {
        this.sortingProperty = this.propertyMap[key];
    };

    Metadata.prototype.setListTitle = function setListTitle(title) {
        this.title = title;
    };

    Metadata.prototype.setSettingType = function setSettingType(settingType) {
        this.settingType = settingType;
    };

    Metadata.Person = new Metadata();
    Metadata.Person.add("name", "Namn").listable(1, 1);
    Metadata.Person.add("FirstName", "Förnamn", "firstName").listable();
    Metadata.Person.add("LastName", "Efternamn").listable();
    Metadata.Person.add("PersonalNumber", "Personnummer (komplett)").listable(2);
    Metadata.Person.add("PersonalNumberDate", "Personnummer (datum)", "PersonalNumber | ergoPnDate").listable();
    Metadata.Person.add("Title", "Sysselsättning").listable();
    Metadata.Person.add("Area", "Område").listable();
    Metadata.Person.add("Comment", "Kommentar").listable();
    Metadata.Person.add("emailPublic.Email", "E-post (offentlig)").listable();
    Metadata.Person.add("emailInternal.Email", "E-post (2)").listable();
    Metadata.Person.add("emailPrivate.Email", "E-post (3)").listable();
    Metadata.Person.add("phoneWork.Number", "Tel (arbete)").listable();
    Metadata.Person.add("phoneMobile.Number", "Tel (mobil)").listable();
    Metadata.Person.add("phoneHome.Number", "Tel (bostad)").listable();
    Metadata.Person.add("phoneHoliday.Number", "Tel (fritid)").listable();
    Metadata.Person.add("homeAddress", "Adress (bostad)", "homeAddress | ergoAddress").listable();
    Metadata.Person.add("homeAddress.Address", "Gatuadress (bostad)").listable();
    Metadata.Person.add("homeAddress.ZipCode", "Postnummer (bostad)").listable();
    Metadata.Person.add("homeAddress.City", "Postort (bostad)").listable();
    Metadata.Person.add("distributionAddress", "Adress (utskick)", "distributionAddress | ergoAddress").listable();
    Metadata.Person.add("distributionAddress.Address", "Gatuadress (utskick)").listable();
    Metadata.Person.add("distributionAddress.ZipCode", "Postnummer (utskick)").listable();
    Metadata.Person.add("distributionAddress.City", "Postort (utskick)").listable();
    Metadata.Person.add("urlHomePage.Url", "Hemsida", "Website").listable();
    Metadata.Person.add("urlPhoto.Url", "Foto", "PhotoUrl").listable();
    Metadata.Person.add("Party.Name", isTroman ? "Partinamn" : "Kategorinamn").listable(3);
    Metadata.Person.add("Party.Abbreviation", isTroman ? "Partibeteckning" : "Kategoriförkortning").listable();
    Metadata.Person.add("Division.Name", "Valkrets").listable();
    Metadata.Person.add("ConsentDate", "Samtyckesdatum", "ConsentDate | ergoDate").listable();
    Metadata.Person.add("LastLookupTimestamp", "Senast uppdaterad från SPAR", "LastLookupTimestamp | ergoDateTime").listable();
    Metadata.Person.setListTitle('Lista - Personer');
    Metadata.Person.setSettingType(0);

    Metadata.Party = new Metadata();
    Metadata.Party.add("Name", "Namn").listable(1);
    Metadata.Party.add("Abbreviation", isTroman ? "Partibeteckning" : "Förkortning").listable(2);
    Metadata.Party.add("SortingCode", "Sorteringskod", "Active ? SortingCode : ''").listable(0, 1);
    Metadata.Party.setSortingProperty('SortingCode');
    Metadata.Party.setListTitle(isTroman ? 'Lista - Partier' : 'Lista - Kategorier');
    Metadata.Party.setSettingType(1);

    Metadata.Organization = new Metadata();
    Metadata.Organization.add("Name", "Namn").listable(1);
    Metadata.Organization.add("Abbreviation", "Förkortning").listable();
    Metadata.Organization.add("SortingCode", "Sorteringskod", "Active ? SortingCode : ''").listable(0, 1);
    Metadata.Organization.add("Comment", "Information (offentlig)", "PublicInformation").listable(2);
    Metadata.Organization.add("Information", "Kommentar (intern)", "InternalComment").listable();
    Metadata.Organization.add("Account", "Konto").listable();
    Metadata.Organization.add("Email.Email", "E-post").listable();
    Metadata.Organization.add("PhoneNumber.Number", "Telefon", "Phone").listable();
    Metadata.Organization.add("MainAddress", "Adress", "MainAddress | ergoAddress").listable();
    Metadata.Organization.add("VisitationAddress", "Besöksadress", "VisitationAddress | ergoAddress").listable();
    Metadata.Organization.add("OrganizationType.Name", "Organisationstyp").listable();
    Metadata.Organization.add("%CurrentMandate.Start", "Nuvarande mandatperiod - Start", "getCurrentMandate().Start | ergoDate").listable();
    Metadata.Organization.add("%CurrentMandate.End", "Nuvarande mandatperiod - Slut", "getCurrentMandate().End | ergoDate").listable();
    Metadata.Organization.add("%LastMandate.Start", "Sista mandatperiod - Start", "getLastMandate().Start | ergoDate").listable();
    Metadata.Organization.add("%LastMandate.End", "Sista mandatperiod - Slut", "getLastMandate().End | ergoDate").listable();
    Metadata.Organization.setSortingProperty('SortingCode');
    Metadata.Organization.setListTitle('Lista - Organisationer');
    Metadata.Organization.setSettingType(2);

    Metadata.Mission = new Metadata();
    Metadata.Mission.add("Person.name", "Person - Namn", "Person != null ? Person.name : 'Vakant'").listable(1);
    Metadata.Mission.add("Person.FirstName", "Person - Förnamn", "Person != null ? Person.firstName : ''").listable();
    Metadata.Mission.add("Person.LastNameOrVacant", "Person - Efternamn", "Person != null ? Person.LastName : 'Vakant'").listable();
    Metadata.Mission.add("Person.PersonalNumber", "Person - Personnummer (komplett)").listable();
    Metadata.Mission.add("Person.PersonalNumberDate", "Person - Personnummer (datum)", "Person.PersonalNumber | ergoPnDate").listable();
    Metadata.Mission.add("Person.Comment", "Person - Kommentar").listable();
    Metadata.Mission.add("Person.emailPublic.Email", "Person - E-post (offentlig)").listable();
    Metadata.Mission.add("Person.emailInternal.Email", "Person - E-post (2)").listable();
    Metadata.Mission.add("Person.emailPrivate.Email", "Person - E-post (3)").listable();
    Metadata.Mission.add("Person.phoneWork.Number", "Person - Tel (arbete)").listable();
    Metadata.Mission.add("Person.phoneMobile.Number", "Person - Tel (mobil)").listable();
    Metadata.Mission.add("Person.phoneHome.Number", "Person - Tel (bostad)").listable();
    Metadata.Mission.add("Person.phoneHoliday.Number", "Person - Tel (fritid)").listable();
    Metadata.Mission.add("Person.homeAddress", "Person - Adress (bostad)", "Person.homeAddress | ergoAddress").listable();
    Metadata.Mission.add("Person.distributionAddress", "Person - Adress (utskick)", "Person.distributionAddress | ergoAddress").listable();
    Metadata.Mission.add("MandatePeriod.Organization.Name", "Organisation").listable();
    Metadata.Mission.add("MandatePeriod.Start", "Mandatperiod - Start", "MandatePeriod.Start | ergoDate").listable();
    Metadata.Mission.add("MandatePeriod.End", "Mandatperiod - Slut", "MandatePeriod.End | ergoDate").listable();
    Metadata.Mission.add("Party.Name", isTroman ? "Partinamn (Uppdrag)" : "Kategorinamn").listable();
    Metadata.Mission.add("Party.Abbreviation", isTroman ? "Partibeteckning (Uppdrag)" : "Kategoriförkortning (Uppdrag)").listable();
    Metadata.Mission.add("MissionType.Name", "Uppdragstyp").listable(2);
    Metadata.Mission.add("OrderNumber", "Ordningsnummer").listable(0, 1);
    Metadata.Mission.add("Start", "Uppdrag Start", "Start | ergoDate").listable();
    Metadata.Mission.add("End", "Uppdrag Slut", "End | ergoDate").listable();
    Metadata.Mission.add("DecisionClause", "Beslutsparagraf").listable();
    Metadata.Mission.add("Comment", "Kommentar").listable();
    Metadata.Mission.add("EmployeeNumber", "Anställningsnummer").listable();
    Metadata.Mission.add("%PersonalSubstitutes", "Personliga ersättare", function formatSubstitutes(mission) {
        let sorted = _.sortBy(mission.Substitutes, "name");
        return _.map(sorted, x => x.name);
    }).listable();
    Metadata.Mission.add("%Divisions", "Valkretsar", function formatDivisions(mission) {
        let sorted = _.sortBy(mission.Divisions, "Name");
        return _.map(sorted, x => x.Name);
    }).listable();
    Metadata.Mission.setSortingProperty('OrderNumber');
    Metadata.Mission.setListTitle('Lista - Uppdrag');
    Metadata.Mission.setSettingType(3);

    Metadata.MissionType = new Metadata();
    Metadata.MissionType.add("Name", "Namn").listable(1, 1);
    Metadata.MissionType.add("Abbreviation", "Förkortning").listable(2);
    Metadata.MissionType.add("TrustMission", "Förtroendeuppdrag", "TrustMission | ergoYesEmpty").listable(3);
    Metadata.MissionType.add("IsSubstitute", "Ersättare", "IsSubstitute | ergoYesEmpty").listable();
    Metadata.MissionType.add("IsGroundForGratuity", "Gratifikation", "IsGroundForGratuity | ergoYesEmpty").listable();
    Metadata.MissionType.add("IsPresidium", "Presidium", "IsPresidium | ergoYesEmpty").listable();
    Metadata.MissionType.setListTitle('Lista - Uppdragstyper');
    Metadata.MissionType.setSettingType(4);

    Metadata.Division = new Metadata();
    Metadata.Division.add("Name", "Namn").listable(1);
    Metadata.Division.add("Abbreviation", "Förkortning").listable(2);
    Metadata.Division.add("SortingCode", "Sorteringskod", "Active ? SortingCode : ''").listable(0, 1);
    Metadata.Division.setSortingProperty('SortingCode');
    Metadata.Division.setListTitle('Lista - Valkretsar');
    Metadata.Division.setSettingType(5);

    Metadata.OrganizationType = new Metadata();
    Metadata.OrganizationType.add("Name", "Namn").listable(1);
    Metadata.OrganizationType.add("SortingCode", "Sorteringskod", "Active ? SortingCode : ''").listable(0, 1);
    Metadata.OrganizationType.add("Description", "Beskrivning").listable(2);
    Metadata.OrganizationType.setSortingProperty('SortingCode');
    Metadata.OrganizationType.setListTitle('Lista - Organisationstyper');
    Metadata.OrganizationType.setSettingType(6);

    Metadata.Meeting = new Metadata();
    Metadata.Meeting.add("Organization.Name", "Organisation").listable(1);
    Metadata.Meeting.add("Designation", "Mötesbenämning").listable(2);
    Metadata.Meeting.add("Location", "Lokal").listable();
    Metadata.Meeting.add("Date", "Datum", "Date | ergoDate").listable(3, 1);
    Metadata.Meeting.add("ActiveMeetingTime", "Tid", "MeetingTime").listable(4, 2);
    Metadata.Meeting.add("PublicInformation", "Information (offentlig)").listable();
    Metadata.Meeting.add("InternalComment", "Kommentar (intern)").listable();
    Metadata.Meeting.add("IsPublic", "Offentligt", "IsPublic | ergoYesEmpty").listable();
    Metadata.Meeting.setListTitle('Lista - Möten');
    Metadata.Meeting.setSettingType(7);

    // This used to be Metadata.Attendance which is no longer used.
    // The same setting type and keys has been used to preserve backward compatibility.
    Metadata.AttendanceModel = new Metadata();
    Metadata.AttendanceModel.add("Person.name", "Namn", "getPerson().name").listable(1);
    Metadata.AttendanceModel.add("Person.PersonalNumber", "Personnummer", "getPerson().PersonalNumber").listable();
    Metadata.AttendanceModel.add("Person.PersonalNumberDate", "Personnummer (datum)", "getPerson().PersonalNumber | ergoPnDate").listable();
    Metadata.AttendanceModel.add("PresentTimeString", "Närvarande", "presentTime").listable(2);
    Metadata.AttendanceModel.add("PresentSubstituteTimeString", "Närvarande (ersättare)", "servingTime").listable();
    Metadata.AttendanceModel.add("Organization.Name", "Organisation", "attendance.getOrganization().Name").listable();
    Metadata.AttendanceModel.add("MissionType.Name", "Uppdragstyp", "attendance.getMissionType().Name").listable();
    Metadata.AttendanceModel.add("Comment", "Kommentar", "comment").listable(3);
    Metadata.AttendanceModel.add("$$order", "Närvaroordning").listable(0, 1);
    Metadata.AttendanceModel.setListTitle('Närvarolista');
    Metadata.AttendanceModel.setSettingType(8);

    Metadata.Equipment = new Metadata();
    Metadata.Equipment.add("Name", "Namn").listable(1, 1);
    Metadata.Equipment.add("EquipmentType.name", "Typ").listable(1, 1);
    Metadata.Equipment.add("Serial", "Serienummer").listable();
    Metadata.Equipment.add("LoanDate", "Utlånad", "LoanDate | ergoDate").listable();
    Metadata.Equipment.add("ExpireDate", "Återlämnas", "ExpireDate | ergoDate").listable();
    Metadata.Equipment.add("ReturnDate", "Återlämnad", "ReturnDate | ergoDate").listable();
    Metadata.Equipment.add("Organization.Name", "Organisation").listable();
    Metadata.Equipment.add("Comment", "Kommentar").listable();
    Metadata.Equipment.setSettingType(9);

    Metadata.Award = new Metadata();
    Metadata.Award.add("AwardDate", "Datum", "AwardDate | ergoDate").listable();
    Metadata.Award.add("Description", "Beskrivning").listable(1, 1);
    Metadata.Award.add("Comment", "Kommentar").listable(2, 2);
    Metadata.Award.setSettingType(10);

    Metadata.WageType = new Metadata();
    Metadata.WageType.add("Code", "Löneart").listable(1, 1);
    Metadata.WageType.add("Name", "Namn").listable(4);
    Metadata.WageType.add("Information", "Information").listable(4);
    Metadata.WageType.add("%LastPeriod.From", "Från (senaste)", "Periods[0].From | ergoDate").listable(2, 2);
    Metadata.WageType.add("%LastPeriod.WageModel", "Typ (senaste)", "Periods[0].WageModel | ergoEnumWageModel").listable(3);
    Metadata.WageType.add("%LastPeriod.Account", "Konto (senaste)", "Periods[0].Account").listable();
    Metadata.WageType.add("%LastPeriod.UnitPeriod", "Period (senaste)", "Periods[0].UnitPeriod").listable();
    Metadata.WageType.add("%LastPeriod.SubPeriod", "Delningstal (senaste)", "Periods[0].SubPeriod").listable();
    Metadata.WageType.add("%LastPeriod.UnitPrice", "à-pris (senaste)", "Periods[0].UnitPrice").listable();
    Metadata.WageType.setSettingType(11);

    Metadata.WageCalculation = new Metadata();
    Metadata.WageCalculation.add("Name", "Namn").listable(1, 1);
    Metadata.WageCalculation.setSettingType(12);

    Metadata.WageGroup = new Metadata();
    Metadata.WageGroup.add("Name", "Namn").listable(1, 1);
    Metadata.WageGroup.add("Description", "Beskrivning").listable(2);
    Metadata.WageGroup.setSettingType(13);

    return Metadata;

}]);
